import { ChangeEvent, RefObject } from 'react'
import classes from './ChatWidget.module.scss'
import { IconPaperclip, IconSend } from './icons'

interface Props {
  value: string
  onChange: (text: string) => void
  onSend: () => void
  sending: boolean
  placeholder: string
  inputRef: RefObject<HTMLTextAreaElement>
}

/** Alt giriş alanı: işlem çubuğu + (ataç, textarea, gönder) + alt bilgi satırı. */
export default function ChatInput({ value, onChange, onSend, sending, placeholder, inputRef }: Props) {
  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    onChange(e.target.value)
    const el = e.target
    el.style.height = 'auto'
    el.style.height = `${Math.min(el.scrollHeight, 128)}px`
  }

  return (
    <div className={classes.inputArea}>
      {sending && (
        <div className={classes.processingBar} aria-hidden='true'>
          <div className={classes.processingBarFill} />
        </div>
      )}

      <div className={classes.inputContainer}>
        {/* Backend dosya kabul etmiyor; buton tasarım bütünlüğü için görsel/pasif. */}
        <button
          type='button'
          className={`${classes.attachBtn} ${classes.tipTop}`}
          data-tip='Dosya ekleme (yakında)'
          aria-label='Dosya ekleme (yakında)'
          aria-disabled='true'
        >
          <IconPaperclip />
        </button>
        <textarea
          ref={inputRef}
          className={classes.input}
          value={value}
          rows={1}
          placeholder={placeholder}
          onChange={handleChange}
          onKeyDown={e => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault()
              onSend()
            }
          }}
          disabled={sending}
        />
        <button
          type='button'
          className={`${classes.sendBtn} ${classes.tipTopRight}`}
          data-tip='Gönder'
          onClick={onSend}
          disabled={sending || !value.trim()}
          aria-label='Gönder'
        >
          <IconSend />
        </button>
      </div>

      <div className={classes.footerMeta}>
        <span className={classes.footerHint}>Enter ile gönder · Shift+Enter ile yeni satır</span>
        <p className={classes.disclaimer}>
          Index AI yanıtları bazen hatalı olabilir. Lütfen önemli bilgileri doğrulayın.
        </p>
      </div>
    </div>
  )
}
